import { motion } from "framer-motion";
import { Wallet, RefreshCw, BarChart3, ArrowRight } from "lucide-react";

const steps = [
  {
    number: "01",
    icon: Wallet,
    title: "Connect Wallet",
    description: "Link your Hyperliquid wallet using WalletConnect. Read-only access only."
  },
  {
    number: "02",
    icon: RefreshCw,
    title: "Sync Trades",
    description: "We fetch your trading history and portfolio data from Hyperliquid."
  },
  {
    number: "03",
    icon: BarChart3,
    title: "Get Your Scorecard",
    description: "View your Sharpe ratio, drawdowns, win rate, and more in seconds."
  }
];

export const HowItWorks = () => {
  return (
    <section className="py-24 md:py-32 relative bg-card/30">
      <div className="container px-4">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Three steps to <span className="text-primary">clarity</span>
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            No complex setup. No API keys needed. Just connect and analyze.
          </p>
        </motion.div>

        {/* Steps */}
        <div className="max-w-4xl mx-auto">
          <div className="relative">
            {/* Connection line */}
            <div className="hidden md:block absolute top-1/2 left-0 right-0 h-px bg-border -translate-y-1/2" />
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-4">
              {steps.map((step, index) => (
                <motion.div
                  key={step.number}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.2, duration: 0.5 }}
                  className="relative"
                >
                  <div className="stat-card text-center pt-10">
                    {/* Step number */}
                    <div className="absolute -top-1 left-1/2 -translate-x-1/2 bg-background px-3">
                      <span className="text-xs font-mono text-primary">{step.number}</span>
                    </div>
                    
                    {/* Icon */}
                    <div className="flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mx-auto mb-4">
                      <step.icon className="w-8 h-8 text-primary" />
                    </div>
                    
                    <h3 className="text-xl font-semibold mb-2">{step.title}</h3>
                    <p className="text-sm text-muted-foreground">{step.description}</p>
                  </div>
                  
                  {/* Arrow for desktop */}
                  {index < steps.length - 1 && (
                    <div className="hidden md:flex absolute top-1/2 -right-2 z-10 -translate-y-1/2">
                      <ArrowRight className="w-4 h-4 text-muted-foreground" />
                    </div>
                  )}
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
